import api from './api-config';

const BASE = '/metrics';

export const getLibrary = async () => {
    const response = await api.get(`${BASE}/library`);
    return response.data;
};

export const getActiveMetrics = async () => {
    const response = await api.get(BASE);
    return response.data;
};

export const activateMetric = async (metricKey) => {
    const response = await api.post(`${BASE}/activate`, { metric_key: metricKey });
    return response.data;
};

export const deactivateMetric = async (metricKey) => {
    const response = await api.delete(`${BASE}/${metricKey}`);
    return response.data;
};

export const calculateMetric = async (metricKey, timeRange = 'this_month') => {
    const response = await api.post(`${BASE}/${metricKey}/calculate?time_range=${timeRange}`);
    return response.data;
};

export const calculateAll = async (timeRange = 'this_month') => {
    const response = await api.post(`${BASE}/calculate-all?time_range=${timeRange}`);
    return response.data;
};

export const reorderMetrics = async (metricKeys) => {
    const response = await api.put(`${BASE}/reorder`, { metric_keys: metricKeys });
    return response.data;
};
